import { graphql } from "gatsby";
import React, { type FC, type HTMLAttributes } from "react";

import {
	IframeEmbedContent,
	extractPrintImageData,
} from "../IframeEmbedContent";
import { MembershipGateContainer } from "../MembershipGateContainer";

import * as styles from "./IframeGrid.module.scss";

interface Props extends HTMLAttributes<HTMLElement> {
	node: Queries.ParagraphIframeGridFragment;
	loggedIn?: boolean;
}

export const IframeGrid: FC<Props> = ({ node, loggedIn }) => {
	const iframes = node.relationships?.field_iframes;

	if (!iframes?.length || iframes.length <= 0) return null;

	return (
		<div className={styles.container}>
			{iframes.map((paragraph) => {
				if (!paragraph) return null;

				if (paragraph.field_gated_content && !loggedIn)
					return (
						<MembershipGateContainer
							key={paragraph.id}
							variant="media"
							reason="no-account"
						/>
					);

				return (
					<IframeEmbedContent
						key={paragraph?.id}
						className={styles.component}
						embedHtml={paragraph?.field_embed_code?.processed || ""}
						printImage={extractPrintImageData(paragraph)}
					/>
				);
			})}
		</div>
	);
};

export const fragment = graphql`
    fragment ParagraphIframeGrid on paragraph__iframe_grid {
        __typename
        id
        relationships {
            field_iframes {
                id
                field_gated_content
                field_embed_code {
                    processed
                }
                ...EmbedParagraphPrintImage
            }
        }
    }
`;

export default IframeGrid;
